module.exports = __webpack_public_path__ + "static/media/symbol-defs.6a79f175.svg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/icon/symbol-defs.svg
// module id = 413
// module chunks = 0